<template>
  <div class="app-container" style="background: #f4f5f7;">
    <BjSteps active="3" :title="$t('route.BusinessrateCalculator')" :defaultOptions="[$t('rateCalculator.ConsignmentDetails'), $t('toolsProfit.calculate'), $t('billingPage.Download')]">
      <template slot="right">
        <el-button type="primary" class="main-btn" @click="returns">{{ $t('backText') }}</el-button>
      </template>
    </BjSteps>
    <el-form ref="form" size="mini" :model="queryParams" :rules="rules" class="bj-query-form bj-query-form-for-cal-height">
      <div class="newClsbox">
        <BjDivider>{{ $t('rateCalculator.TransitDetails') }}</BjDivider>
        <el-row :gutter="20" style="padding: 0 10px">
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.CustomerName')" prop="totalPalletQty">
              <BjInputNumber v-model="queryParams.customName" disabled clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('rateCalculator.table.profitmargin')" prop="standardPallet">
              <BjInputNumber v-model="queryParams.profitMargin" disabled clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('rateCalculator.table.ShippingAddress')" prop="fromAddress">
              <BjInputNumber v-model="queryParams.fromAddress" disabled clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="newClsbox" style="margin-top:10px;padding-bottom:10px;">
        <BjDivider>{{ $t('rateCalculator.ConsignmentDetails') }}</BjDivider>
        <el-row :gutter="20" style="padding: 0 10px">
          <el-col>
            <el-table :data="tableData" border script max-height="500px">
              <el-table-column :label="$t('rateCalculator.tables.NO')" type="index" width="55" align="center" />
              <el-table-column :label="$t('BjDialogListConfig.orderNo')" prop="orderNumber" align="center"  width="80"/>
              <el-table-column :label="$t('rateCalculator.tables.deliveryAddress')" prop="deliveryAddress" align="center"  width="125" ></el-table-column>
              <el-table-column :label="$t('rateCalculator.tables.Country')" prop="toCountry" align="center" />
              <el-table-column :label="$t('rateCalculator.tables.State')" prop="toState" align="center" />
              <el-table-column :label="$t('rateCalculator.tables.Postcode')" prop="toPostcode" align="center" />
              <el-table-column :label="$t('rateCalculator.tables.Suburb')" prop="toSuburb" align="center" />
              <el-table-column :label="$t('rateCalculator.tables.SKUs')" prop="skus" align="center" />
              <el-table-column :label="$t('rateCalculator.tables.Weight')" prop="weight" align="center"  width="125" />
              <el-table-column :label="$t('rateCalculator.tables.Length')" prop="length" align="center" width="120"  />
              <el-table-column :label="$t('rateCalculator.tables.width')" prop="width" align="center" width="120"  />
              <el-table-column :label="$t('rateCalculator.tables.Height')" prop="height" align="center"  width="110" />
              <el-table-column :label="$t('rateCalculator.tables.Qty')" prop="qty" align="center"   width="110"/>
              <el-table-column :label="$t('rateCalculator.tables.Volume')" prop="volume" align="center" width="150"  />
              <el-table-column :label="$t('rateCalculator.tables.PiceFromCustomer')" prop="customerPrice" align="center"   width="145"/>
            </el-table>
          </el-col>
        </el-row>
      </div>
      <div class="newClsbox" style="margin-top:10px;padding-bottom:10px;">
        <BjDivider>{{ $t('rateCalculator.LogisticsService') }}</BjDivider>
        <el-row :gutter="15" style="padding: 0 10px">
          <el-col>
            <el-table :data="tableData1" border script max-height="500px">
              <el-table-column :label="$t('rateCalculator.tables.NO')" type="index" width="55" align="center" />
              <el-table-column :label="$t('rateCalculator.tables.inquiryList')" align="center">
                <template slot-scope>Best Courier Service Price</template>
              </el-table-column>
              <el-table-column :label="`${$t('rateCalculator.tables.totalCost')}${$t('rateCalculator.tables.exclGST')}`" prop="totalCost" align="center"></el-table-column>
              <el-table-column :label="`${$t('rateCalculator.tables.totalQuote')}${$t('rateCalculator.tables.exclGST')}`" prop="totalQuote" align="center" />
              <el-table-column :label="$t('rateCalculator.tables.profitMargin')" prop="profitMargin" align="center" width="180"  />
              <el-table-column :label="$t('rateCalculator.tables.totalCustomPrice')" prop="totalCustomPrice" align="center" width="180"  />
              <el-table-column :label="$t('rateCalculator.tables.totalDiff')" prop="totalDiff" align="center" width="180"  />
              <el-table-column :label="$t('rateCalculator.tables.totalPercentage')" prop="totalPercentage" align="center"  width="180" />
            </el-table>
            <div style="font-size:12px;margin-top:10px;">{{ $t('Note: margin =[Quote -Cost] / Quote; Difference Percentage=[Quote - Total Price From customer) / Total price From Customer]') }}</div>
          </el-col>
        </el-row>
      </div>

      <div class="newClsbox" style="margin-top:10px;padding-bottom:10px;">
        <BjDivider>{{ $t('rateCalculator.DownloadPreview') }}
            <template #right>
                <el-button type="primary" class="main-btn" @click="onDown">{{ $t('billingPage.Download') }}</el-button>
            </template>
        </BjDivider>
        <el-row :gutter="18" style="padding: 0 10px">
            <el-col>
                <el-table :data="tableData2" border script max-height="500px">
                    <el-table-column :label="$t('rateCalculator.tables.NO')" type="index" width="48" align="center" />
                    <el-table-column :label="$t('BjDialogListConfig.orderNo')" prop="orderNumber" align="center"  width="94" />
                    <el-table-column :label="$t('rateCalculator.tables.deliveryAddress')" prop="deliveryAddress"  width="120" align="center"></el-table-column>
                    <el-table-column :label="$t('rateCalculator.tables.Country')" prop="toCountry" align="center" width="90" />
                    <el-table-column :label="$t('rateCalculator.tables.State')" prop="toState" align="center" width="95" />
                    <el-table-column :label="$t('rateCalculator.tables.Postcode')" prop="toPostcode" align="center" width="115" />
                    <el-table-column :label="$t('rateCalculator.tables.Suburb')" prop="toSuburb" align="center"  width="82" />
                    <el-table-column :label="$t('rateCalculator.tables.SKUs')" prop="skus" align="center"  width="98"/>
                    <el-table-column :label="$t('rateCalculator.tables.Weight')" prop="weight" align="center"  width="116" />
                    <el-table-column :label="$t('rateCalculator.tables.Length')" prop="length" align="center" width="94" />
                    <el-table-column :label="$t('rateCalculator.tables.width')" prop="width" align="center" width="95" />
                    <el-table-column :label="$t('rateCalculator.tables.Height')" prop="height" align="center"  width="95" />
                    <el-table-column :label="$t('rateCalculator.tables.Qty')" prop="qty" align="center" width="63" />
                    <el-table-column :label="$t('rateCalculator.tables.Volume')" prop="volume" align="center"  width="138"/>
                    <el-table-column :label="`${$t('rateCalculator.tables.bestPrice')}${$t('rateCalculator.tables.exclGST')}`" prop="bestPrice" align="center" width="78" />
                    <el-table-column :label="$t('rateCalculator.tables.provider')" prop="provider" align="center" width="140"  />
                    <el-table-column :label="$t('rateCalculator.tables.customerPrice')" prop="customerPrice" align="center"   width="150"/>
                    <el-table-column :label="$t('rateCalculator.tables.differPrice')" prop="differPrice" align="center"  width="90" />
                    <el-table-column :label="$t('rateCalculator.tables.diffPercentage')" prop="diffPercentage" align="center"  width="150" />
                </el-table>
                <div style="font-size:12px;margin-top:10px;">{{ $t('rateCalculator.chargeonyour') }}</div>
            </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import { afterApi } from '@/api';
import viewMiXin from '@/utils/view-mixin.js'
import { downloadBlob } from '@/utils/index';
const defaultFormData = () => {
    return {
        id: null,
    };
};
export default {
    name: 'BusinessFreightCalculationDetails',
    components: {
    },
    mixins: [viewMiXin],
    data() {
        return {
            colSpan: 6,
            queryParams: {
                customName: null,
                profitMargin: null,
                fromAddress: null,


            },
            inquiryList: "Best Courier Service Price",
            form: defaultFormData(),
            tableData: [],
            tableData1: [],
            tableData2: [],
        };
    },
    computed: {
        customerList() {
            return this.$store.getters.customerList;
        },
        rever() {
            return this.inquiryList
        }
    },
    watch: {},
    created() {
        const { id } = this.$route.query;
        this.form.id = id;
        this.getData(id);
    },
    methods: {
        assignSummaryToArray(summaryObj, arr) {
            return arr.map(obj => ({ ...obj, ...summaryObj }));
        },
        async getData(id) {
            afterApi.LogisticsList({ id })
                .then((res) => {
                    this.tableData = res.content[0].orderItems
                    this.tableData1 = [res.content[0].summary]
                    this.tableData2 = this.assignSummaryToArray(res.content[0].summary, res.content[0].orderItems);
                    console.log(res.content[0].summary, "789");
                    this.queryParams.customName = res.content[0].summary.customName
                    this.queryParams.profitMargin = res.content[0].summary.profitMargin
                    this.queryParams.fromAddress = res.content[0].summary.fromAddress
                });
        },
        async onDown() {
            const res = await afterApi.detailsExports({ id: this.form.id });
            downloadBlob(res, 'Online Store Product.xlsx');
        },

        returns() {
            this.complete('BusinessrateCalculator');
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep .app-container .el-form-item__label {
  display: none;
}

::v-deep .innerOrderNo .el-input-group__append {
  background: $main-dark;
  color: #ffffff;
}
</style>
